import {createSelector} from 'reselect'
import {selectUserPanel} from '../selector'

export const selectEditUserPanel = createSelector(
    selectUserPanel,
    (userPanel) => userPanel.editPanel
)

export const getEditUserId = state => selectEditUserPanel(state).userId

export const isLoading = state => selectEditUserPanel(state).loading

export const isUpdatingData = state => selectEditUserPanel(state).updatingData

export const isLoaded = state => selectEditUserPanel(state).loaded

export const isPanelOpened = state => selectEditUserPanel(state).userId !== null

export const isUpdatingWorkSchedule = state => selectEditUserPanel(state).updatingWorkSchedule

export const getErrorBackup = state => selectEditUserPanel(state).errorBackup

export const getSelectedTab = state => selectEditUserPanel(state).selectedTab

export const isNeedToLoadData = createSelector(
    isLoaded,
    isPanelOpened,
    (loaded, opened) => opened === true && loaded === false
)



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/selectors.js